module.exports = Object.freeze({
  DATE_AND_TIME: "Date & Time",
  IR_SENSOR_SIZE: "IR Sensor Size",
  BACKGROUND_TEMPERATURE: "Background Temperature",
  EMISSIVITY: "Emissivity",
  TRANSMISSION: "Transmission",
  CALIBRATION_RANGE: "Calibration Range",
  CAMERA_SERIAL: "Camera Serial",
  CAMERA_MODEL: "Camera Model",
  CAMERA_MANUFACTURER: "Camera Manufacturer",
});
